import {
  MaberetachaStateTypes,
  MaberetachaActionTypes,
} from "./Maberetacha.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: MaberetachaStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const MaberetachaReducer = (
  state: MaberetachaStateTypes = INITIAL_STATE,
  action: any
): MaberetachaStateTypes => {
  switch (action.type) {
    case MaberetachaActionTypes.FETCH_ALL_MABERETACHA:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case MaberetachaActionTypes.FETCH_ALL_MABERETACHA_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MaberetachaActionTypes.FETCH_ALL_MABERETACHA_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MaberetachaActionTypes.FETCH_ALL_MABERETACHA_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case MaberetachaActionTypes.FETCH_ONE_MABERETACHA:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case MaberetachaActionTypes.FETCH_ONE_MABERETACHA_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MaberetachaActionTypes.FETCH_ONE_MABERETACHA_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MaberetachaActionTypes.FETCH_ONE_MABERETACHA_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default MaberetachaReducer;
